import React from 'react'

interface SelectWrapperProps {
  label: string
  children: React.ReactNode
  onBlur?: () => void
  'data-testid'?: string
}

export const SelectWrapper: React.FC<SelectWrapperProps> = ({
  label,
  children,
  onBlur,
  'data-testid': dataTestId,
}) => {
  return (
    <div onBlur={onBlur} data-testid={dataTestId} className="w-full text-left">
      <span className="mb-1 block text-sm font-medium text-primary">{label}</span>
      {children}
    </div>
  )
}
